module.exports = __webpack_public_path__ + "static/assets/398fd9596275cec30cf26fee0c947d26.svg";